// src/auth/msalInstance.js
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./msalConfig";

export const msalInstance = new PublicClientApplication(msalConfig);

// single shared init promise
let _initPromise;
export function ensureMsalInitialized() {
  if (!_initPromise) {
    _initPromise = msalInstance.initialize(); // returns a promise in MSAL v3+
  }
  return _initPromise;
}
